import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { playSoftChime } from "@/lib/chime";
import { API, useAuth } from "@/App";

const POLL_MS = 30000;

// Shows the 1-hour / 15-min van reminders in-app (chime + toast) for both rider and driver.
export default function VanReminderListener() {
  const { token, user } = useAuth();
  const navigate = useNavigate();
  const shownRef = useRef(new Set());

  useEffect(() => {
    if (!token || !user || !["customer", "artisan"].includes(user.role)) return undefined;
    const base = user.role === "artisan" ? "/artisan/trip" : "/customer/trip";
    let alive = true;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/rideshare/van-reminders/pending?token=${token}`);
        for (const r of data || []) {
          if (!alive || shownRef.current.has(r.id)) continue;
          shownRef.current.add(r.id);
          playSoftChime(`van-${r.id}`);
          toast(r.title, {
            description: r.body,
            duration: 15000,
            action: { label: "Open trip", onClick: () => navigate(`${base}/${r.booking_id}`) },
            className: "van-reminder-toast",
          });
          axios.post(`${API}/rideshare/van-reminders/${r.id}/seen?token=${token}`).catch(() => {});
        }
      } catch (_) { /* offline — next tick */ }
    };
    poll();
    const iv = setInterval(poll, POLL_MS);
    const onWs = (e) => { if (e?.detail?.type === "van_reminder") poll(); };
    window.addEventListener("yorm-ws-message", onWs);
    return () => { alive = false; clearInterval(iv); window.removeEventListener("yorm-ws-message", onWs); };
  }, [token, user, navigate]);

  return null;
}
